"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFeedbackIfNeeded = exports.FETCH_FEEDBACK = void 0;
var utils_1 = require("../../utils");
exports.FETCH_FEEDBACK = (0, utils_1.networkActionTypes)("FETCH_FEEDBACK");
var fetchFeedback = (0, utils_1.networkAction)(exports.FETCH_FEEDBACK, "/feedback");
exports.fetchFeedbackIfNeeded = (0, utils_1.makeIfNeededAction)(fetchFeedback, "feedback");
